import { RouterView } from 'vue-router'

export const reportsRoutes = [
  {
    path: 'reports',
    component: () => import('@/modules/reports/views/GenericReportsView.vue'),
    children: [
      {
        path: 'sales',
        component: RouterView,
        children: [
          {
            name: 'organizationReportBilling',
            path: 'billing',
            component: () => import('@/modules/reports/views/sales/OrganizationReport.vue'),
            meta: {
              locationTypes: ['organization']
            }
          },

          // Location Routes
          {
            name: 'simplifiedBillingReport',
            path: '/reporting/simplified-billing',
            component: () => import('@/modules/reports/views/sales/SimplifiedBillingReport.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'revenueSources',
            path: 'sources',
            component: () => import('@/modules/reports/views/sales/RevenueSources.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'activity',
            path: 'activity',
            component: () => import('@/modules/reports/views/sales/ActivityReport.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'promotionsReport',
            path: 'promotions',
            component: () => import('@/modules/reports/views/sales/PromotionsReport.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'fraudReport',
            path: 'fraud-control',
            component: () => import('@/modules/reports/views/sales/FraudReport.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          }
        ]
      },
      {
        path: 'catalog',
        component: RouterView,
        children: [
          {
            name: 'productsOrganizationReport',
            path: 'products',
            component: () => import('@/modules/reports/views/catalog/ProductsReport.vue'),
            props: { scope: 'organization' },
            meta: {
              locationTypes: ['organization']
            }
          },
          {
            name: 'modifiersOrganizationReport',
            path: 'modifiers',
            component: () => import('@/modules/reports/views/catalog/ModifiersReport.vue'),
            props: { scope: 'organization' },
            meta: {
              locationTypes: ['organization']
            }
          },
          {
            name: 'combosOrganizationReport',
            path: 'combos',
            component: () => import('@/modules/reports/views/catalog/CombosReport.vue'),
            props: { scope: 'organization' },
            meta: {
              locationTypes: ['organization']
            }
          },
          {
            name: 'productsLocationReport',
            path: 'products',
            component: () => import('@/modules/reports/views/catalog/ProductsReport.vue'),
            props: { scope: 'location' },
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'categories',
            path: 'categories',
            component: () => import('@/modules/reports/views/catalog/CategoriesReport.vue'),
            props: { scope: 'location' },
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'modifiersLocationReport',
            path: 'modifiers',
            component: () => import('@/modules/reports/views/catalog/ModifiersReport.vue'),
            props: { scope: 'location' },
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'combosLocationReport',
            path: 'combos',
            component: () => import('@/modules/reports/views/catalog/CombosReport.vue'),
            props: { scope: 'location' },
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          }
        ]
      },
      {
        path: 'performance',
        component: RouterView,
        children: [
          {
            name: 'your-restaurant',
            path: 'your-restaurant',
            component: () => import('@/modules/reports/views/performance/YourRestaurantReport.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'daily-analytics',
            path: 'daily-analytics',
            component: () => import('@/modules/reports/views/performance/DailyAnalyticsReport.vue'),
            meta: {
              locationTypes: ['organization', 'location', 'singleLocation']
            }
          },
          {
            name: 'reservations',
            path: 'reservations',
            component: () => import('@/modules/reports/views/performance/ReservationsReport.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'ratings',
            path: 'ratings',
            component: () => import('@/modules/reports/views/performance/RatingsReport.vue'),
            props: { scope: 'organization' },
            meta: {
              locationTypes: ['organization', 'singleLocation']
            }
          },
          {
            name: 'employeesReport',
            path: 'employees',
            component: () => import('@/modules/reports/views/performance/EmployeesReport.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'deliveryOrderStatusesReport',
            path: 'statuses',
            component: () =>
              import('@/modules/reports/views/performance/DeliveryOrderStatusReport.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'ratingsLocationReport',
            path: 'ratings',
            component: () => import('@/modules/reports/views/performance/RatingsReport.vue'),
            props: { scope: 'location' },
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          }
        ]
      },
      {
        path: 'financial-records',
        component: RouterView,
        children: [
          // Organization routes
          {
            name: 'invoices',
            path: 'invoices',
            component: () => import('@/modules/reports/views/financialRecords/InvoicesReport.vue'),
            props: { scope: 'organization' },
            meta: {
              locationTypes: ['organization', 'singleLocation']
            }
          },
          {
            name: 'movements',
            path: 'movements',
            component: () => import('@/modules/reports/views/financialRecords/MovementsReport.vue'),
            props: { scope: 'organization' },
            meta: {
              locationTypes: ['organization', 'singleLocation']
            }
          },

          // Location routes
          {
            name: 'cashReport',
            path: 'cash',
            component: () => import('@/modules/reports/views/financialRecords/CashReport.vue'),
            meta: {
              locationTypes: ['location', 'singleLocation']
            }
          },
          {
            name: 'invoicesLocationReport',
            path: 'location-invoices',
            component: () => import('@/modules/reports/views/financialRecords/InvoicesReport.vue'),
            props: { scope: 'location' },
            meta: {
              locationTypes: ['location']
            }
          },
          {
            name: 'movementsLocationReport',
            path: 'location-movements',
            component: () => import('@/modules/reports/views/financialRecords/MovementsReport.vue'),
            props: { scope: 'location' },
            meta: {
              locationTypes: ['location']
            }
          }
        ]
      },
      {
        name: 'explore',
        path: 'explore',
        component: () => import('@/modules/reports/views/common/Explore.vue'),
        meta: {
          locationTypes: ['organization', 'singleLocation']
        }
      },
      {
        name: 'custom',
        path: 'custom/:reportId',
        component: () => import('@/modules/reports/views/common/CustomReport.vue'),
        meta: {
          locationTypes: ['organization', 'singleLocation']
        }
      }
    ]
  },
  {
    name: 'predefinedReports',
    path: '/reports/predefined-reports',
    component: () => import('@/modules/reports/views/financialRecords/PredefinedReports.vue'),
    props: { scope: 'location' },
    meta: {
      locationTypes: ['location', 'singleLocation', 'organization']
    }
  }
]
